import React, {Component} from 'react';
import {Col, Row} from "react-bootstrap";
import EBOKWatekFormularzOdpowiedzi from "./EBOKWatekFormularzOdpowiedzi";
import EBOKService from "../EBOKService";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import DownloadUtilities from "../../../../utilities/DownloadUtilities";

export default class EBOKWatekTresc extends Component {
    constructor(props) {
        super(props);
        this.state = {
            zgloszenia: [],
            loading: true
        };
    }

    componentDidMount() {
        if (Boolean(this.props.zgloszenie)) {
            this.ustawZgloszenieJakoOdczytane()
            let zgloszenia = this.props.zgloszenie.bokZglWpisy
            zgloszenia.sort(function (a, b) {
                return a.idZglWpis - b.idZglWpis
            });
            console.log(zgloszenia)
            this.setState({zgloszenia: zgloszenia, loading: false})

        }
    }

    renderPlik(plik) {
        if (plik.typ.indexOf('image') > -1) {
            return (<div>
                <div className={'thumbnail'} style={{maxWidth: '400px', margin: '5px 0'}}>
                    <img src={'data:image/jpg;base64,' + plik.dane}
                         className={'img-ressponsive'}/>
                </div>
                <a onClick={() => DownloadUtilities.pobierzPlik(plik.dane, plik.typ, plik.nazwa)}
                   title={'Kliknij aby pobrać'}
                   style={{fontSize: '16px', cursor: 'pointer'}}>
                    <i className={'fa fa-paperclip'}></i> {plik.nazwa}</a>
            </div>)
        } else {
            return <div>
                <a onClick={() => DownloadUtilities.pobierzPlik(plik.dane, plik.typ, plik.nazwa)}
                   title={'Kliknij aby pobrać'}
                   style={{fontSize: '16px', cursor: 'pointer'}}>
                    <i className={'fa fa-paperclip'}></i> {plik.nazwa}</a>
            </div>
        }

    }

    renderDataIGodzina(str) {
        return str.substr(0, 16).replace('T', ' ')
    }

    ustawZgloszenieJakoOdczytane() {
        EBOKService.odczytajZgloszenie(this.props.zgloszenie.idZgl).then(function (response) {
            console.log('ustawiono zgloszenie jako odczytane')
        }.bind(this))
    }


    render() {

        const zgloszenia = this.state.zgloszenia
        const loading = this.state.loading

        return (
            <div>
                {loading ? null : <div>
                    <Row>
                        <Col xs={12}>
                            <div id={'pierwszaWiadomosc'}>
                                <div className={'wiadomoscContainer wiadomoscKlient'}>
                                    <div className={'heading'}>
                                        <span>Temat i treść zgłoszenia</span>
                                        <div className={'pull-right'}>
                                            <i className={'fa fa-clock-o'} style={{marginRight: '5px'}}></i>
                                            <span>{this.renderDataIGodzina(zgloszenia[0].dataWpisu)}</span>
                                        </div>
                                    </div>
                                    <div className={'content'}>
                                        <div className={'tytul'}>
                                            {this.props.zgloszenie.temat}
                                        </div>
                                        <div className={'tresc'}>
                                            <p>
                                                {zgloszenia[0].tresc}
                                            </p>
                                            {
                                                Boolean(zgloszenia[0].plik) ?
                                                    <div>
                                                        {this.renderPlik(zgloszenia[0].plik)}
                                                    </div>
                                                    :
                                                    ''
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <div id={'watekZgloszenia'}>
                                <Row>
                                    {
                                        this.props.zgloszenie.bokZglWpisy.map((item, index) => {
                                            if (index !== 0)   // pierwsza jest do tematu
                                                return (
                                                    <Col xs={12}>
                                                        <div
                                                            className={(item.kierunek === 'KLIENT') ? 'wiadomoscContainer wiadomoscKlient' : 'wiadomoscContainer'}>
                                                            <div className={'heading'}>
                                                            <span>#{index} Odpowiedź <span><i className={'fa fa-user'}
                                                                                              style={{margin: '0 5px 0 15px'}}></i>
                                                                {(item.kierunek === 'KLIENT') ? (this.props.zgloszenie.imieKl + ' ' + this.props.zgloszenie.nazKl) : 'BOK'}</span></span>
                                                                <div className={'pull-right'}>
                                                                    <i className={'fa fa-clock-o'}
                                                                       style={{marginRight: '5px'}}></i>
                                                                    <span>{this.renderDataIGodzina(item.dataWpisu)}</span>
                                                                </div>
                                                            </div>
                                                            <div className={'content'}>
                                                                <div className={'tresc'}>
                                                                    <p>
                                                                        {item.tresc}
                                                                    </p>
                                                                    {
                                                                        Boolean(item.plik) ?
                                                                            <div>
                                                                                {this.renderPlik(item.plik)}
                                                                            </div>
                                                                            :
                                                                            ''
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                )
                                        })
                                    }
                                </Row>
                            </div>
                        </Col>
                    </Row>
                    <TopIf isTrue={this.props.zgloszenie.status === 0 || this.props.zgloszenie.status === 2}>
                        <EBOKWatekFormularzOdpowiedzi handleSendResponse={(odp) => this.props.handleSendResponse(odp)}
                                                      czyJednorazowy={this.props.czyJednorazowy}/>
                    </TopIf>
                </div>}</div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/componentsWatek/EBOKWatekTresc.js